import React from 'react'
import '../../assets/css/CustomStyle.css'
import blogimage from '../../assets/images/blog.png'


export default function BlogGrid() {
    const Blog = [
        {
          title: 'Lorem ipsum dolor sit amet consectetur. Eget gravida lacus posuere mauris ridiculus nunc amet .',
          subtitle: "Lorem ipsum dolor sit amet consectetur. In ultrices dui adipiscing posuere quisque morbi tincidunt.",
          image: blogimage,
        },
        {
          title: 'Lorem ipsum dolor sit amet consectetur. Eget gravida lacus posuere mauris ridiculus nunc amet .',
          subtitle: "Lorem ipsum dolor sit amet consectetur. In ultrices dui adipiscing posuere quisque morbi tincidunt.",
          image: blogimage,
        },
        {
          title: 'Lorem ipsum dolor sit amet consectetur. Eget gravida lacus posuere mauris ridiculus nunc amet .',
          subtitle: "Lorem ipsum dolor sit amet consectetur. In ultrices dui adipiscing posuere quisque morbi tincidunt.",
          image: blogimage,
        },
        {
          title: 'Lorem ipsum dolor sit amet consectetur. Eget gravida lacus posuere mauris ridiculus nunc amet .',
          subtitle: "Lorem ipsum dolor sit amet consectetur. In ultrices dui adipiscing posuere quisque morbi tincidunt.",
          image: blogimage,
        },
        {
          title: 'Lorem ipsum dolor sit amet consectetur. Eget gravida lacus posuere mauris ridiculus nunc amet .',
          subtitle: "Lorem ipsum dolor sit amet consectetur. In ultrices dui adipiscing posuere quisque morbi tincidunt.",
          image: blogimage,
        },
        {
          title: 'Lorem ipsum dolor sit amet consectetur. Eget gravida lacus posuere mauris ridiculus nunc amet .',
          subtitle: "Lorem ipsum dolor sit amet consectetur. In ultrices dui adipiscing posuere quisque morbi tincidunt.",
          image: blogimage,
        },
        {
          title: 'Lorem ipsum dolor sit amet consectetur. Eget gravida lacus posuere mauris ridiculus nunc amet .',
          subtitle: "Lorem ipsum dolor sit amet consectetur. In ultrices dui adipiscing posuere quisque morbi tincidunt.",
          image: blogimage,
        },
        {
          title: 'Lorem ipsum dolor sit amet consectetur. Eget gravida lacus posuere mauris ridiculus nunc amet .',
          subtitle: "Lorem ipsum dolor sit amet consectetur. In ultrices dui adipiscing posuere quisque morbi tincidunt.",
          image: blogimage,
        },
        {
          title: 'Lorem ipsum dolor sit amet consectetur. Eget gravida lacus posuere mauris ridiculus nunc amet .',
          subtitle: "Lorem ipsum dolor sit amet consectetur. In ultrices dui adipiscing posuere quisque morbi tincidunt.",
          image: blogimage,
        },
    
      ];
  return (
    <div className='section-padding  grid 999:grid-cols-3 600:grid-cols-2 grid-cols-1 1350:gap-[2.5rem] 999:gap-[2.3rem] 768:gap-[2rem] 600:gap-[1.8rem] gap-[25px] 1440:pb-[5rem] 999:pb-[3.8rem] 768:pb-[2.9rem] pb-[25px]'>
        {Blog.map((blog) => (
        <div className='choose-card p-[20px] rounded-[30px] relative'>
            <div className='relative  mx-auto'>
                <button className='py-[8px] px-[16px] rounded-[2.5rem] absolute right-[10px] top-[12px]  text-[.875rem] primray-bg text-white'>Tips</button>
                <img className='rounded-[20px] w-full h-[18.5rem] mx-auto' src={blogimage} alt="" />
            </div>
            <div className='pt-[20px]'>
                <p className='text-[1.125rem] font-[450]'>Lorem ipsum dolor sit amet consectetur. Eget gravida lacus posuere mauris ridiculus nunc amet .</p>
                <p className='text-[.9375rem] font-light py-[10px]'>1 Feb 2022 - 30 Apr 2022</p>
                <p className='text-[1rem] font-light'>Lorem ipsum dolor sit amet consectetur. In ultrices dui adipiscing posuere quisque morbi tincidunt.</p>
            </div>
        </div>))}
    </div>
  )
}
